import React from 'react'
import * as Style from './style';
import * as images from '../../images';
const Header = () => {
    return (
        <Style.HeaderComp>
            <Style.LinkIcon to={-1} >
                <Style.ImageArrow src={images.Arrow} />
            </Style.LinkIcon>
            <Style.TextComp>
                <Style.HeadSection variant='h3' >
                    اختبار القسم الأول
                </Style.HeadSection>
                <Style.TextHeader>
                    أرسل حلول اختبار القسم الأول واكتب علامتك المتوقعة.
                </Style.TextHeader>
            </Style.TextComp>
        </Style.HeaderComp>
    )
}

export default Header